export const getAreaName = (studyFilters, areaId) => {
  if (!(studyFilters && studyFilters.filters && studyFilters.filters.Areas)) {
    return "";
  }
  const area = studyFilters.filters.Areas.find((a) => a.id === areaId);
  return area ? area.name : "";
};
